import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import WhySection from "./components/WhySection";
import HowItWorks from "./components/HowItWorks";
import Destinations from "./components/Destinations";
import Testimonials from "./components/Testimonials";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <>
      <Hero />
      <TrustBar />
      <WhySection />
      <HowItWorks />
      <Destinations />
      <Testimonials />
      <CTASection />
    </>
  );
}